import { useTranslate } from '@tolgee/react'
import { Header } from '@tom-ui/ui'
import { PATHS } from '@tom-ui/utils'
import { computed } from 'mobx'
import { observer } from 'mobx-react-lite'
import { BreadcrumpItem } from 'modules/ui/src/theme/components/breadcrumbs/Breadcrumb'
import { FC } from 'react'
import { Helmet } from 'react-helmet-async'

type Props = {
  containerNumber?: string | null
}

export const ContainerHistoryHeader: FC<Props> = observer(({ containerNumber }) => {
  const { t } = useTranslate()

  const title = t('history', 'History') + ' - ' + containerNumber

  const breadCrumbs: BreadcrumpItem[] = computed(() => {
    return [
      { label: t(PATHS.masterData.title), route: PATHS.masterData.url },
      {
        label: PATHS.masterData.containers.title,
        route: PATHS.masterData.containers.url,
      },
      {
        label: title,
      },
    ]
  }).get()

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <Header title={title} position='relative' breadcrumbs={breadCrumbs} />
    </>
  )
})
